import React from 'react';
import ReactDOM from 'react-dom/client';
import './authFetch';
import App from './App';
import AuthGate from './AuthGate';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthGate>
    <App />
  </AuthGate>
);
